<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="100"
      :rules="ruleValidate"
    >
      <FormItem label="当前的用户">
        {{ formItem.us }}
      </FormItem>
      <FormItem label="角色" prop="role_id">
        <Select v-model="formItem.role_id" style="width: 200px">
          <Option
            v-for="item in roleList"
            :value="item.role_id"
            :key="item.role_id"
          >
            {{ item.role_name }}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
// 引入用户相关API方法
import { usersAdd, usersUpdateRole } from '@/api/user'
// 引入角色相关API方法
import { rolesPage } from '@/api/role'

export default {
  name: 'UsersAddUpdate', // 组件名称
  data() {
    return {
      // 表单数据对象
      formItem: {
        us: '', // 用户账号
        id: '', // 用户ID
        role_id: '', // 角色ID
      },
      // 表单验证规则
      ruleValidate: {
        role_id: [ // 角色ID验证规则
          {
            required: true, // 必填项
            message: '请选择角色', // 错误消息
            trigger: 'change', // 触发验证的事件（值改变时）
            type: 'number', // 验证类型为数字
          },
        ],
      },
      // 角色列表
      roleList: [
        // { roleId: 24, roleName: "超级管理员" },
      ],
      // 控制模态框的显示状态
      open: false,
      // 模态框标题
      title: '分配角色',
      // 提交按钮的加载状态
      loading: false,
    }
  },
  methods: {
    // 初始化组件的方法，接收参数并设置表单数据
    init(params) {
      console.log('分配角色 - 初始化参数:', params) // 打印传入的参数
      // 根据传入的参数设置表单数据
      // 注意：表单绑定的是 role_id，所以这里也要设置 role_id
      const roleId = params.roleId || params.role_id || params.roles?.[0]?.roleId || params.roles?.[0]?.role_id
      this.formItem = {
        us: params.us,
        id: params.id,
        role_id: roleId ? (typeof roleId === 'number' ? roleId : parseInt(roleId, 10)) : ''  // 确保是数字
      }
      console.log('分配角色 - 表单数据:', this.formItem)
      this.title = '分配角色' // 设置模态框标题
      this.open = true // 显示模态框
    },
    // 处理表单提交的方法
    ok(name) {
      // 使用表单验证
      this.$refs[name].validate((valid) => {
        if (!valid) return // 如果验证失败，直接返回
        
        // 准备提交的数据，确保字段名正确
        const postData = {
          id: this.formItem.id,
          role_id: this.formItem.role_id  // 使用 role_id 字段名
        }
        
        console.log('分配角色 - 提交数据:', postData)
        this.loading = true
        
        // 调用API方法更新用户角色
        usersUpdateRole(postData)
          .then((res) => {
            this.loading = false
            console.log('分配角色 - API响应:', res.data)
            if (res.data.code === 200) { // 如果响应码为200，表示成功
              this.$Message.success('角色分配成功') // 显示成功消息
              this.cancel('formItem') // 重置表单
              this.$emit('reload') // 触发reload事件，可能用于重新加载数据
            } else {
              this.$Message.error(res.data.msg) // 显示错误消息
            }
          })
          .catch((err) => {
            this.loading = false
            console.error('分配角色失败:', err)
            this.$Message.error(err) // 显示错误消息
          })
      })
    },
    // 关闭模态框并重置表单的方法
    cancel(name) {
      // 重置表单数据
      this.formItem = {
        us: '',
        id: '',
        role_id: '',  // 使用 role_id 而不是 roleId
      }
      // 调用表单的resetFields方法重置验证状态
      if (this.$refs[name]) {
        this.$refs[name].resetFields()
      }
      this.open = false // 隐藏模态框
    },
    // 获取角色列表的方法
    getRolesList() {
      // 调用API方法获取角色列表
      rolesPage()
        .then((res) => {
          if (res.data.code === 200) { // 如果响应码为200，表示成功
            const data = res.data // 获取响应数据
            this.roleList = data.data // 将角色数据赋值给roleList
          } else {
            this.$Message.error(res.data.msg) // 显示错误消息
          }
        })
        .catch((err) => {
          this.$Message.error(err) // 显示错误消息
        })
    },
  },
  created() {
    // 组件创建后立即获取角色列表
    this.getRolesList()
  },
}
</script>

